/**
 * Thin convenience hook over the Zustand auth store.
 *
 * Components should prefer this over `useAuthStore` directly so the public API
 * is stable even if we later swap the store implementation.
 */

import { useAuthStore } from '@/stores/auth';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const accessToken = useAuthStore((s) => s.accessToken);
  const hydrated = useAuthStore((s) => s.hydrated);
  const login = useAuthStore((s) => s.login);
  const logout = useAuthStore((s) => s.logout);

  return {
    user,
    accessToken,
    hydrated,
    isAuthenticated: Boolean(accessToken && user),
    login,
    logout,
  };
}
